import { Button, MenuItem, Select } from '@mui/material'
import React, { useEffect, useState } from 'react'
import "./NextResParty.css"
import axiosApiInstance from '../axios';

const NextResParty = ({ onPartyChange, info, setIsNextResPartyChanged, selectedUser }) => {

  const [nextResParty, setNextResParty] = useState([])
  const [nextResponsibleId, setNextResponsibleId] = useState(0)

  useEffect(() => {
    axiosApiInstance.get(`/nextResponsible/${info}`)
      .then(req => setNextResParty(req.data.data))
  }, [])


  const inputEvent7 = (event) => {
    setNextResponsibleId(event.target.value)
  };



  const saveParty = () => {

    let data = JSON.stringify({
      "id": info,
      "nextResponsibleId": nextResponsibleId

    });

    axiosApiInstance.post('/nextResponsible/Update', data).then(function (response) {
      if (response.data.succeeded) {
        setIsNextResPartyChanged(true);
      }
    }).catch((error) => {
      console.error("Error:", error);
  });
    onPartyChange();
  }

  return (
    <>
      <div>

        <Select className='selnextParty'
          name="nextParty"
          value={nextResponsibleId}
          onChange={inputEvent7}>
          <MenuItem value="0" disabled>Select</MenuItem>
          {nextResParty.map((nxt, index) => (
            <MenuItem disabled={selectedUser === nxt.fullName} key={index} value={nxt.id}>{nxt.fullName}</MenuItem>
          ))
          }
        </Select>

      </div>
      <div className="party-buttons">
        <Button className="edit-save-btn" disabled={nextResponsibleId == 0} onClick={saveParty}>Save</Button>
        <Button className="edit-cancel-btn" onClick={onPartyChange}>Cancel</Button>
      </div>
    </>
  )
}

export default NextResParty
